import React from 'react';

import SvgIcon from '@mui/material/SvgIcon';

interface Props {
    color?: string;
    opacity?: string;
    fillOpacity?: string;
    size?: number;
}

export const CustomSportsTennis = ({ color, opacity = '1', fillOpacity = '1', size = 20 }: Props): JSX.Element => (
    <SvgIcon style={{ width: size, height: size }} viewBox={`0 0 ${size} ${size}`}>
        <path
            d={
                'M2.854 16.6667L1.6665 15.5L5.08317 12.0833C5.51373 11.6528 5.80887 11.1146 5.96859 10.4688C6.12831 9.82293 6.20817 8.83335 6.20817 7.50002C6.20817 6.69446 6.38873 5.90279 6.74984 5.12502C7.11095 4.34724 7.62484 3.62502 8.2915 2.95835C9.55539 1.69446 10.9512 0.979182 12.479 0.812516C14.0068 0.645849 15.2637 1.06946 16.2498 2.08335C17.2498 3.08335 17.6665 4.34724 17.4998 5.87502C17.3332 7.40279 16.6248 8.79168 15.3748 10.0417C14.7082 10.7083 13.9859 11.2222 13.2082 11.5833C12.4304 11.9445 11.6387 12.125 10.8332 12.125C9.48595 12.125 8.49984 12.2014 7.87484 12.3542C7.24984 12.507 6.71512 12.8056 6.27067 13.25L2.854 16.6667ZM8.58317 9.70835C9.23595 10.3472 10.1179 10.5833 11.229 10.4167C12.3401 10.25 13.3332 9.72918 14.2082 8.85418C15.0971 7.96529 15.6283 6.96877 15.8019 5.8646C15.9755 4.76043 15.7359 3.89585 15.0832 3.27085C14.4165 2.60418 13.545 2.35418 12.4686 2.52085C11.3922 2.68752 10.4026 3.21529 9.49984 4.10418C8.62484 4.97918 8.09359 5.96877 7.90609 7.07293C7.71859 8.1771 7.94428 9.05557 8.58317 9.70835ZM14.9998 19.1667C14.0832 19.1667 13.2984 18.8403 12.6457 18.1875C11.9929 17.5347 11.6665 16.75 11.6665 15.8333C11.6665 14.9167 11.9929 14.132 12.6457 13.4792C13.2984 12.8264 14.0832 12.5 14.9998 12.5C15.9165 12.5 16.7012 12.8264 17.354 13.4792C18.0068 14.132 18.3332 14.9167 18.3332 15.8333C18.3332 16.75 18.0068 17.5347 17.354 18.1875C16.7012 18.8403 15.9165 19.1667 14.9998 19.1667Z'
            }
            fill={color}
            opacity={opacity}
            fillOpacity={fillOpacity}
        />
    </SvgIcon>
);
